import React from 'react';
import {
  ViewSidebar,
  Search,
  History,
  PersonOutline,
  HelpOutline,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

type Props = {
  onToggle: () => void;
};

const SidebarCollapsed: React.FC<Props> = ({ onToggle }) => {
  const navigate = useNavigate();
  return (
    <aside className="fixed top-0 left-0 h-full w-14 bg-gray-50 flex flex-col items-center justify-between py-4 border-r">
      {/* 上部ロゴ */}
      <div className="flex flex-col items-center space-y-6">
        <div className="w-6 h-6 rounded bg-black" /> {/* ロゴ代替 */}
        <button onClick={onToggle}>
          <ViewSidebar fontSize="small" />
        </button>
        <button onClick={() => navigate('/search-entry')}>
          <Search fontSize="small" />
        </button>
        <History fontSize="small" />
      </div>

      {/* 下部設定系 */}
      <div className="flex flex-col items-center space-y-6">
        <PersonOutline fontSize="small" />
        <HelpOutline fontSize="small" />
      </div>
    </aside>
  );
};

export default SidebarCollapsed;
